<template>
  <div class="my-2" style="border: 1px solid #eaecef; border-radius: 10px">
    <div
      class="d-flex text-lg justify-content-between mb-2 px-1"
      style="
        background-color: #f4f6f7;
        padding-bottom: 6px;
        padding-top: 6px;
        font-size: 15px;
      "
    >
      <div class="d-flex align-items-center flex-grow flex-1 w-50">
        Search members by
        <b-form-select
          v-model="matchType"
          style="max-width: 65px; margin-left: 5px; margin-right: 5px"
          :options="queryFilterModeOptions"
          text-field="label"
          size="sm"
        ></b-form-select>
        of the following:
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <b-button variant="outline-danger" @click="clearFilters">Clear Search</b-button>
      </div>
    </div>
    <div class="mx-1 mb-1">
      <div class="mb-2">
        <SearchFilterRow
          v-for="(filter, index) of filters"
          :key="index"
          class="mb-1"
          :filter.sync="filter"
          :region-options="regionOptions"
          :member-status-options="memberStatusOptions"
          :member-type-options="memberTypeOptions"
          :member-title-options="memberTitleOptions"
          :member-designation-options="memberDesignationOptions"
          :selected-fields="selectedFields"
          :geo-filter-values="geoFilterValues"
          @remove="remove(index)"
        />
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <b-button variant="outline-primary" @click="addFilter">Add a Filter</b-button>
        <b-button variant="primary" @click="search">Search</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "lodash";
import { BButton, BFormSelect } from "bootstrap-vue";
import SearchFilterRow from "./search-filter-row.vue";

export default {
  components: {
    BButton,
    BFormSelect,
    SearchFilterRow,
  },
  data() {
    return {
      filters: [],
      matchType: "all",
      regionOptions: [],
      memberStatusOptions: [],
      memberTypeOptions: [],
      memberTitleOptions: [],
      memberDesignationOptions: [],
    };
  },
  computed: {
    selectedFields() {
      return this.filters.map((field) => field.field);
    },
    geoFilterValues() {
      const geoFilterNames = [
        "area",
        "district",
        "assembly",
        "region",
      ];
      return this.filters.filter((filter) => {
        return geoFilterNames.includes(filter.field);
      })
      .reduce((acc, filter) => {
        acc[filter.field] = filter.value
        return acc;
      }, {});
    }
  },
  mounted() {
    this.fetchChurchRegions();
    this.fetchMemberStatus();
    this.fetchMemberTypes();
    this.fetchMemberTitles();
    this.fetchMemberDesignations();
  },
  methods: {
    async fetchChurchRegions() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoRegions();
        const { data } = request.data;
        this.regionOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        console.log("error", error);
        console.log("there was an error fetching regions");
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberStatus() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchMemberStatus();
        const { data } = request.data;
        console.log("data", data);
        this.memberStatusOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        console.log("error", error);
        console.log("there was an error fetching regions");
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberTypes() {
      try {
        this.loading = true;

        const query = {
          limit: 1000,
        }

        const request = await this.useJwt().mainService.memberTypes.list(query);
        const { data } = request.data;

        this.memberTypeOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message);
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberTitles() {
      try {
        this.loading = true;

        const query = {
          limit: 1000,
        }

        const request = await this.useJwt().mainService.memberTitles.list(query);
        const { data } = request.data;

        const options = [];
        data.forEach((opt) => {
          opt.categories.forEach((category) => {
            options.push({
              label: category.title,
              value: category._id,
            });
          });
        });

        this.memberTitleOptions = options;
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message);
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberDesignations() {
      try {
        this.loading = true;

        const query = {
          limit: 1000,
        }

        const request = await this.useJwt().mainService.memberDesignations.list(query);
        const { data } = request.data;

        const options = [];
        data.forEach((opt) => {
          opt.categories.forEach((category) => {
            options.push({
              label: category.designation,
              value: category._id,
            });
          });
        });

        this.memberDesignationOptions = options;
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message);
      } finally {
        this.loading = false;
      }
    },
    clearFilters() {
      this.filters = [];
      this.search();
    },
    search() {
      this.$emit("search", { filters: this.filters, filter_mode: this.matchType });
    },
    addFilter() {
      this.filters.push({
        field: null,
        operator: 'equal_to',
        type: "text",
        value: "",
      });
    },
    remove(index) {
      this.filters.splice(index, 1);
    },
  },
};
</script>

<style></style>
